import { UserItemProps } from "apis/user";
import axios from "axios";
import { AppMessage } from "components";
import { store } from "store";
import { authLoginSuccess } from "store/auth";
import { OutputBaseProps } from "utils/types/API";
import { apiAuthPermission } from "./auth-permission";

interface ApiLoginInputProps {
    username: string;
    password: string;
}

type ApiLoginOutputProps = OutputBaseProps<{ token: string; user: UserItemProps }, ApiLoginInputProps>;

export const apiLogin = async (data: ApiLoginInputProps) => {
    const res = (await axios.post<ApiLoginOutputProps>("/api/auth/login", data))
        .data;
    if (res.code === 0 && res.data) {
        axios.defaults.headers["Authorization"] = `Bearer ${res.data.token}`;
        const authPermission = await apiAuthPermission()
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
        store.dispatch(authLoginSuccess({
            ...res.data,
            permissions: authPermission.data || []
        }));
    }
    return res;
};
